import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { getData } from './actions'
import BlockUi from 'react-block-ui';
import { Line } from 'react-chartjs-2';

class Chart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataChart: {
        labels: [],
        datasets: [
          {
            label: 'Tiền',
            data: [0, 0],
          }
        ]
      },
    }
  }
  componentDidMount() {
    const requestData = {
      tu_ngay: this.props.tu_ngay,
      den_ngay: this.props.den_ngay,
      store_id: this.props.store_id,
      type: this.props.type
    }
    this.props.getData(requestData)
  }

  render() {
    const {
      requesting,
      data
    } = this.props
    return (
      <BlockUi tag="div" blocking={requesting} className="w-100">
        <Line
          data={data}
          width={50}
          height={500}
          options={{
            maintainAspectRatio: false,
            title: {
              display: true,
              text: this.props.title || 'Doanh số bán',
              fontSize: 25,
              fontColor: "#07a7e3",
              fontStyle: "normal"
            },
            legend: {
              display: true,
              position: 'top'
            },
            scales: {
              yAxes: [{
                ticks: {
                  callback: function (label, index, labels) {
                    return label.toLocaleString(navigator.language, { minimumFractionDigits: 0 });
                  }
                }
              }]
            },
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  tooltipItem.yLabel = tooltipItem.yLabel.toLocaleString(navigator.language, { minimumFractionDigits: 0 });
                  return tooltipItem.yLabel;
                }
              }
            }
          }}
        />
      </BlockUi>
    )
  }
}
const mapStateToProps = state => ({
  data: state.chart.data,
  requesting: state.chart.requesting,
  successful: state.chart.successful,
});

const connected = connect(
  mapStateToProps,
  {
    getData: getData
  }
)(Chart);

export default connected


// WEBPACK FOOTER //
// ./src/components/Chart/Chart.js